/**
 * @file Types related to dialogs
 */

export enum DialogId {
  ComposeChecklistClear = 'compose-checklist-clear',
  ComposeClear = 'compose-clear',
  ComposeClose = 'compose-close',
}
